<template>
  <!-- 计划信息卡片 -->
  <van-row class="cardRow" @click.stop="clickCard(item)" v-for="(item, index) in productsData" :key="index">
    <van-col span="4" v-if="item.imgSrc !== false">
      <div class="imgBox" @click.stop="clickImg(item)">
        <img :src="item.imgSrc" alt="图片缺失" />
      </div>
    </van-col>
    <van-col :span="getPriceSpan(hiddenPrice, item).box">
      <div class="orderIfnBox">
        <p class="planName">{{ item.productName }}</p>
        <div v-if="item.dealerName" class="dealerNameBox">{{ item.productType === 2 ? '使用经销商' : '' }}{{ item.dealerName }}</div>
        <div v-if="item.carInf" style="margin-bottom:8px;">{{ item.carInf }}</div>
        <span v-if="item.productType === 1 && item.carInf" @click.stop="viewUseDealer(item)">可使用经销商:<span class="underline"> 点击查看</span></span>
      </div>
    </van-col>
    <van-col v-if="!(hiddenPrice || item.hiddenPrice)" :span="getPriceSpan(hiddenPrice, item).price">
      <div class="priceBox">
        <!-- <div v-if="item.orderTypeFlag === 3"> -->
        <div>
          <span class="retail">{{ getRetailLabel(item) }}</span>
          <p>¥{{ item.price }}×{{ item.num }}</p>
        </div>
        <!-- <div v-else>
          <span :class="['priceNum', priceWeight ? 'priceWeight ' : '']">¥{{ item.price }} </span>
          <p>×{{ item.num }}</p>
        </div> -->
        <!-- <p v-if="item.currentStatus">{{ item.currentStatus }}</p> -->
      </div>
      <!-- <BottomBtn v-if="item.btnData && item.btnData.length" :data="item.btnData" align="right" @click="clickBtn" size="mini"></BottomBtn> -->
    </van-col>
    <div class="fvr statusBtn">
      <span v-if="item.currentStatus">{{ item.currentStatus }}</span>
      <BottomBtn v-if="item.btnData && item.btnData.length" :data="item.btnData" @click="clickBtn" size="mini" />
    </div>
    <!-- 轮胎服务订单显示退款状态 -->
    <div class="refundStep" v-if="item.statusData && item.statusData.showActive">
      <van-steps :active="item.statusData.active" active-color="#3088c5">
        <van-step>发起退款</van-step>
        <van-step>退款中</van-step>
        <van-step>{{ item.statusData.refundStatusFlag == 5 ? '退款失败' : '退款到账' }}</van-step>
      </van-steps>
      <p class="refundAmount">
        退款金额：<span>¥ {{ (item.statusData && item.statusData.price) || '0' }} 元</span>
      </p>
    </div>
  </van-row>
</template>

<script>
import { reactive, toRefs, computed, ref, nextTick } from 'vue'
import BottomBtn from '@/components/order/BottomBtn'

export default {
  props: {
    data: {
      type: [Object, Array],
      default: () => []
    },
    priceWeight: {
      type: Boolean,
      default: false
    },
    hiddenPrice: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BottomBtn
  },
  emits: ['clickCard', 'clickImg', 'clickBtn', 'viewUseDealer'],
  setup(props, { emit }) {
    let { data, priceWeight } = toRefs(props)
    const state = reactive({
      data: data.value,
      priceWeight: priceWeight.value
    })
    const isArrayFn = value => {
      if (typeof Array.isArray === 'function') {
        return Array.isArray(value)
      } else {
        return Object.prototype.toString.call(value) === '[object Array]'
      }
    }
    const productsData = computed(() => (isArrayFn(data.value) ? data.value : [data.value]))

    const viewUseDealer = data => {
      // console.log('viewUseDealer', data)
      // state.applyDealerParam = { loyaltyId: data.productId, gsCode: data.gsCode }
      // nextTick(() => {
      //   useDealerRef.value.changeShowNUm()
      // })
      emit('viewUseDealer', { ...data, sign: 'loyaltyOrder' })
    }

    const getPriceSpan = (hiddenPrice, item) => {
      let res = { box: 0, price: 0 }
      if (item.imgSrc === false) {
        if (hiddenPrice || item.hiddenPrice) {
          res.box = 24
        } else {
          // res = item.orderTypeFlag === 3 ? { box: 15, price: 9 } : { box: 17, price: 7 }
          res = { box: 15, price: 9 }
        }
      } else {
        if (hiddenPrice || item.hiddenPrice) {
          res.box = 20
        } else {
          // res = item.orderTypeFlag === 3 ? { box: 13, price: 7 } : { box: 15, price: 5 }
          res = { box: 13, price: 7 }
        }
      }
      return res
    }
    const getRetailLabel = item => {
      let res = '经销商自主报价'
      if (item.miniMallOrder === 1) {
        // miniMall迁移订单
        res = '厂商建议零售价'
      }
      if (item.orderTypeFlag === 2 || item.orderTypeFlag === 4) {
        // 核销订单
        res = '厂商建议零售价'
      }
      return res
    }
    const clickCard = v => {
      // console.log('clickCard-->', v)
      emit('clickCard', v)
    }
    const clickImg = v => {
      // console.log("clickImg-->", v);
      emit('clickImg', v)
    }
    const clickBtn = v => {
      emit('clickBtn', v)
    }
    return {
      ...toRefs(state),
      clickCard,
      clickImg,
      clickBtn,
      productsData,
      getPriceSpan,
      getRetailLabel,
      viewUseDealer
      // useDealerRef
    }
  }
}
</script>
<style lang="scss" scoped>
.cardRow {
  width: 100%;
}
.cardRow + .cardRow {
  margin-top: 5px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}
.imgBox,
.imgBox img {
  width: 100%;
  min-width: 55px;
  height: 45px;
}
.orderIfnBox {
  padding-left: 8px;
}
.planName {
  font-size: 14px;
  margin-bottom: 8px;
  color: #333;
  font-weight: 600;
  word-wrap: break-word;
  word-break: normal;
  word-break: break-all;
}
.dealerNameBox {
  margin-bottom: 8px;
  word-wrap: break-word;
  word-break: normal;
  word-break: break-all;
}
.priceBox {
  text-align: right;
  .retail {
    font-size: 12px;
  }
  p {
    margin-top: 5px;
    font-size: 12px;
  }
}
.priceNum {
  font-weight: 600;
}
.priceWeight {
  font-weight: 600;
  color: #3088c5;
}
// 步骤条样式错乱，需要手动处理
.refundStep {
  width: 100%;
  :deep(.van-steps__items) {
    margin: 0 !important;
  }
}
.statusBtn {
  width: 100%;
  span {
    font-size: 12px;
  }
  .btnCompnentBox {
    margin-left: 10px;
  }
}
</style>
